/* FORMA storefront (home + product page) */
(function(){
  'use strict';
  var $ = function(s, r){ return (r || document).querySelector(s); };
  var $$ = function(s, r){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function money(cents){
    var n = (Math.round(cents || 0) / 100).toFixed(2).split('.');
    n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (n[1] === '00' ? n[0] : n.join('.')) + '₪';
  }
  function moneyFull(cents){
    var n = (Math.round(cents || 0) / 100).toFixed(2).split('.');
    n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return n.join('.') + '₪';
  }

  /* ============ Media carousel (video first, then photos) ============ */
  var track = $('#pgalTrack');
  var gallery = { goTo: function(){}, toMedia: function(){}, reveal: function(){} };
  if(track){
    var slides = $$('.pgal-slide', track), dots = $$('#pgalDots span'), thumbs = $$('#pgalThumbs button');
    var current = 0, visible = true;
    function playActive(){
      slides.forEach(function(s, k){
        var v = s.querySelector('video'); if(!v) return;
        if(k === current && visible){ v.muted = true; var p = v.play(); if(p && p.catch) p.catch(function(){}); }
        else v.pause();
      });
    }
    function mark(i){
      if(i === current) return;
      current = i;
      dots.forEach(function(d, k){ d.classList.toggle('on', k === i); });
      thumbs.forEach(function(t, k){ t.classList.toggle('on', k === i); });
      playActive();
    }
    /* Photos are lazy in the markup so they don't compete with the first paint. Inside a sideways
       scroller, though, Safari only starts a lazy photo once it slides into view, which made every
       arrow tap wait for a download. So the neighbours of the current slide are always fetched
       ahead of time, and right after the page has loaded all of them are. */
    function warm(k){
      var s = slides[k]; if(!s) return;
      var img = s.querySelector('img'); if(!img || img.getAttribute('data-warm')) return;
      img.setAttribute('data-warm', '1');
      img.loading = 'eager';
      if(img.decode) img.decode().catch(function(){});
    }
    function warmAround(k){ warm(k); warm(k + 1); warm(k - 1); warm(k + 2); }
    function warmAll(){ for(var k = 0; k < slides.length; k++) warm(k); }
    warmAround(0);
    if(document.readyState === 'complete') setTimeout(warmAll, 200);
    else window.addEventListener('load', function(){ setTimeout(warmAll, 200); });
    ['pointerdown', 'touchstart'].forEach(function(ev){ track.addEventListener(ev, warmAll, { passive: true, once: true }); });

    gallery.goTo = function(i, smooth){
      if(!slides.length) return;
      i = (i + slides.length) % slides.length;
      warmAround(i);
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
      mark(i);
    };
    gallery.toMedia = function(mediaId, smooth){
      if(!mediaId) return;
      for(var k = 0; k < slides.length; k++){
        if(String(slides[k].getAttribute('data-media-id')) === String(mediaId)){ gallery.goTo(k, smooth); return; }
      }
    };
    /* bring the carousel into view (used when the shopper picks a colour further down the page) */
    gallery.reveal = function(){
      var box = $('#pgal'); if(!box) return;
      var hdr = $('.site-header') || $('header');
      var off = 0;
      if(hdr){ var p = getComputedStyle(hdr).position; if(p === 'sticky' || p === 'fixed') off = hdr.offsetHeight; }
      var top = box.getBoundingClientRect().top;
      if(top >= off - 2) return; // already fully in view (e.g. desktop, where it sits beside the buy panel)
      window.scrollTo({ top: window.pageYOffset + top - off - 8, behavior: 'smooth' });
    };
    var ticking = false;
    track.addEventListener('scroll', function(){
      if(ticking) return; ticking = true;
      requestAnimationFrame(function(){ ticking = false; var k = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); warmAround(k); mark(k); });
    }, { passive: true });
    var prev = $('#pgalPrev'), next = $('#pgalNext');
    if(prev) prev.addEventListener('click', function(){ gallery.goTo(current - 1); });
    if(next) next.addEventListener('click', function(){ gallery.goTo(current + 1); });
    thumbs.forEach(function(t){ t.addEventListener('click', function(){ gallery.goTo(parseInt(t.getAttribute('data-i'), 10) || 0); }); });
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es){ es.forEach(function(e){ visible = e.isIntersecting; playActive(); }); }, { threshold: .25 }).observe(track);
    }
    window.addEventListener('resize', function(){ track.scrollTo({ left: current * track.clientWidth, behavior: 'auto' }); });
    playActive();
  }

  /* ============ Buy box: colour, 1 or 2 bags, add to cart ============ */
  var dataEl = $('#forma-data');
  var D = null;
  if(dataEl){ try{ D = JSON.parse(dataEl.textContent); }catch(e){ D = null; } }

  if(D && D.variants && D.variants.length){
    var variants = D.variants, colorPos = D.colorPos || 0;
    var swatches = $('#swatches'), second = $('#secondSwatches'), secondWrap = $('#offerSecond');
    var addBtn = $('#addBtn'), stickyBtn = $('#stickyBtn'), form = $('#buyForm');
    function activeValue(wrap){ var a = wrap && (wrap.querySelector('.swatch.active') || wrap.querySelector('.swatch')); return a ? a.getAttribute('data-value') : null; }
    var state = { c1: activeValue(swatches), c2: activeValue(second) || activeValue(swatches), qty: 1 };

    function variantFor(color){
      if(!colorPos || color == null){
        for(var i = 0; i < variants.length; i++){ if(variants[i].available) return variants[i]; }
        return variants[0];
      }
      for(var k = 0; k < variants.length; k++){ if(variants[k].options[colorPos - 1] === color) return variants[k]; }
      return null;
    }
    function wasFor(v){
      if(v.compare_at_price && v.compare_at_price > v.price) return v.compare_at_price;
      return D.wasEach > v.price ? D.wasEach : 0;
    }
    function setText(sel, txt){ var el = $(sel); if(el) el.textContent = txt; }
    function show(sel, on){ var el = $(sel); if(el) el.hidden = !on; }

    function paint(){
      var v1 = variantFor(state.c1); if(!v1) return;
      var v2 = state.qty === 2 ? (variantFor(state.c2) || v1) : null;
      var idIn = $('#variantId'); if(idIn) idIn.value = v1.id;
      var qtyIn = $('#qtyInput'); if(qtyIn) qtyIn.value = state.qty === 2 && v2 && v2.id === v1.id ? 2 : 1;

      var w1 = wasFor(v1);
      setText('#priceNow', moneyFull(v1.price));
      setText('#priceWas', moneyFull(w1));
      show('#priceWas', w1 > 0);
      var ps = $('#priceSave'); if(ps){ ps.hidden = !(w1 > 0); ps.innerHTML = 'חוסכת <span dir="ltr">' + money(w1 - v1.price) + '</span>'; }

      var o2v = v2 || v1;
      setText('[data-o1-now]', moneyFull(v1.price));
      setText('[data-o1-was]', moneyFull(w1));
      setText('[data-o2-each]', moneyFull(v1.price));
      setText('[data-o2-now]', moneyFull(v1.price + o2v.price));
      setText('[data-o2-was]', moneyFull(w1 + wasFor(o2v)));

      var total = v1.price + (v2 ? v2.price : 0);
      var saved = (w1 > 0 ? w1 - v1.price : 0);
      if(v2){ var w2 = wasFor(v2); saved += (w2 > 0 ? w2 - v2.price : 0) + (D.giftValue || 0); }
      setText('#btnPrice', money(total));
      setText('#saveTotal', money(saved) + (v2 && D.giftValue ? ' (כולל המתנה)' : ''));
      show('#addNote', saved > 0);
      setText('#stickyName', v2 ? '2 תיקים + מתנה' : 'תיק אחד');
      setText('#stickyPrice', money(total));

      var ok = v1.available && (!v2 || v2.available);
      [addBtn, stickyBtn].forEach(function(b){ if(b){ b.classList.toggle('is-disabled', !ok); b.setAttribute('aria-disabled', ok ? 'false' : 'true'); } });
      setText('#addLabel', ok ? 'הוספה לעגלה' : 'אזל מהמלאי');

      [swatches, second].forEach(function(wrap){
        if(!wrap) return;
        $$('.swatch', wrap).forEach(function(sw){ var v = variantFor(sw.getAttribute('data-value')); sw.classList.toggle('soldout', !(v && v.available)); });
      });
    }

    function pick(wrap, sw){
      $$('.swatch', wrap).forEach(function(x){ var on = x === sw; x.classList.toggle('active', on); if(x.hasAttribute('aria-checked')) x.setAttribute('aria-checked', on ? 'true' : 'false'); });
    }
    if(swatches){
      $$('.swatch', swatches).forEach(function(sw){
        sw.addEventListener('click', function(){
          var was = state.c1;
          state.c1 = sw.getAttribute('data-value');
          pick(swatches, sw);
          setText('#colorName', state.c1);
          // the second bag follows the first until the shopper picks its colour herself
          if(second && state.c2 === was){ state.c2 = state.c1; var m = $('.swatch[data-value="' + CSS.escape(state.c1) + '"]', second); if(m) pick(second, m); }
          var v = variantFor(state.c1);
          // jump straight to this colour's photo (no slide-by-slide animation) and bring it into view
          if(v && v.featured_media) gallery.toMedia(v.featured_media.id, false);
          gallery.reveal();
          paint();
        });
      });
    }
    if(second){
      $$('.swatch', second).forEach(function(sw){
        sw.addEventListener('click', function(){ state.c2 = sw.getAttribute('data-value'); pick(second, sw); paint(); });
      });
    }
    $$('#offers input[name="forma_offer"]').forEach(function(r){
      r.addEventListener('change', function(){
        state.qty = parseInt(r.value, 10) === 2 ? 2 : 1;
        $$('#offers .offer-box').forEach(function(b){ b.classList.toggle('is-active', b.contains(r)); });
        if(secondWrap) secondWrap.hidden = state.qty !== 2;
        paint();
      });
    });

    /* add to cart -> cart page (never straight to checkout, so the cart upsells get a chance) */
    var sending = false;
    function busy(on){
      [addBtn, stickyBtn].forEach(function(b){ if(b){ b.classList.toggle('is-sending', on); } });
      setText('#addLabel', on ? 'מוסיפה…' : 'הוספה לעגלה');
    }
    function fail(msg){
      sending = false; busy(false);
      setText('#addLabel', msg || 'שגיאה, נסי שוב');
      if(addBtn) addBtn.classList.add('is-error');
      setTimeout(function(){ if(addBtn) addBtn.classList.remove('is-error'); paint(); }, 2400);
    }
    function addToCart(){
      if(sending) return;
      var v1 = variantFor(state.c1); if(!v1 || !v1.available) return;
      var items = [];
      if(state.qty === 2){
        var v2 = variantFor(state.c2) || v1; if(!v2.available) return;
        if(v2.id === v1.id) items.push({ id: v1.id, quantity: 2 });
        else { items.push({ id: v1.id, quantity: 1 }); items.push({ id: v2.id, quantity: 1 }); }
      } else {
        items.push({ id: v1.id, quantity: 1 });
      }
      sending = true; busy(true);
      var json = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
      fetch('/cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: items }) })
        .then(function(r){ return r.json().then(function(d){ return { ok: r.ok && !d.status, d: d }; }); })
        .then(function(res){
          if(!res.ok){ fail(res.d && res.d.description); return null; }
          if(state.qty !== 2 || !D.giftVariantId) return true;
          // 2 bags: put the free headrest in right away (unless one is already there)
          try{ sessionStorage.removeItem('forma_gift_declined'); }catch(e){}
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function(r){ return r.json(); })
            .then(function(cart){
              var has = (cart.items || []).some(function(it){ return it.variant_id === D.giftVariantId; });
              if(has) return true;
              return fetch('/cart/add.js', { method: 'POST', headers: json,
                body: JSON.stringify({ items: [{ id: D.giftVariantId, quantity: 1, properties: { _gift: 'auto' } }] }) })
                .then(function(){ return true; });
            })
            .catch(function(){ return true; });
        })
        .then(function(done){ if(done) window.location.href = '/cart'; })
        .catch(function(){ fail(); });
    }
    if(form) form.addEventListener('submit', function(e){ e.preventDefault(); addToCart(); });
    if(stickyBtn) stickyBtn.addEventListener('click', addToCart);

    /* sticky bar on phones: only while the main button is off-screen */
    var sticky = $('#stickyAtc');
    if(sticky && addBtn && 'IntersectionObserver' in window){
      var mq = window.matchMedia('(max-width:640px)');
      var offscreen = false;
      function applySticky(){ var on = mq.matches && offscreen; sticky.classList.toggle('show', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true'); }
      new IntersectionObserver(function(es){ es.forEach(function(e){ offscreen = !e.isIntersecting && e.boundingClientRect.top < 0; applySticky(); }); }, { threshold: 0 }).observe(addBtn);
      if(mq.addEventListener) mq.addEventListener('change', applySticky);
    }

    paint();
  }

  /* ============ Rest of the page ============ */
  var mNav = $('#mNav'), mOv = $('#mOverlay');
  function openM(){ if(mNav) mNav.classList.add('open'); if(mOv) mOv.classList.add('open'); }
  function closeM(){ if(mNav) mNav.classList.remove('open'); if(mOv) mOv.classList.remove('open'); }
  if($('#burger')) $('#burger').addEventListener('click', openM);
  if($('#mClose')) $('#mClose').addEventListener('click', closeM);
  if(mOv) mOv.addEventListener('click', closeM);
  if(mNav) $$('a', mNav).forEach(function(a){ a.addEventListener('click', closeM); });

  var header = $('#header');
  if(header) window.addEventListener('scroll', function(){ header.classList.toggle('scrolled', window.scrollY > 10); }, { passive: true });

  $$('.faq-q').forEach(function(q){
    q.setAttribute('aria-expanded', 'false');
    q.addEventListener('click', function(){
      var item = q.parentElement, a = item.querySelector('.faq-a'), open = item.classList.contains('open');
      $$('.faq-item').forEach(function(x){ x.classList.remove('open'); x.querySelector('.faq-a').style.maxHeight = null; x.querySelector('.faq-q').setAttribute('aria-expanded', 'false'); });
      if(!open){ item.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; q.setAttribute('aria-expanded', 'true'); }
    });
  });

  var cards = $$('.ugc-card');
  if(cards.length && 'IntersectionObserver' in window){
    var vIO = new IntersectionObserver(function(es){
      es.forEach(function(e){
        var v = e.target.querySelector('video'); if(!v) return;
        v.muted = true;
        if(e.isIntersecting){ if(v.preload === 'none') v.preload = 'auto'; var p = v.play(); if(p && p.catch) p.catch(function(){}); }
        else v.pause();
      });
    }, { threshold: .6 });
    cards.forEach(function(c){ vIO.observe(c); });
  }
})();

/* ============ Judge.me: its widget text is English-only — swap known phrases for Hebrew ============ */
(function(){
  var dict = {
    'Customer Reviews': 'ביקורות לקוחות',
    'Write a review': 'כתבו ביקורת',
    'More': 'עוד',
    'Less': 'פחות',
    'Read more': 'קראי עוד',
    'Show more': 'עוד',
    'Show less': 'פחות',
    'Load more': 'עוד ביקורות',
    'See more reviews': 'עוד ביקורות',
    'Verified': 'מאומתת',
    'Verified Buyer': 'רוכשת מאומתת',
    'How would you rate this product?': 'איך היית מדרגת את המוצר?',
    'We would love it if you would share a bit about your experience.': 'נשמח לשמוע קצת על החוויה שלך.',
    'Great': 'מעולה',
    'Poor': 'גרוע',
    'Review content (Required)': 'תוכן הביקורת (חובה)',
    'Next': 'הבא',
    'Back': 'חזרה',
    'About you': 'עלייך',
    'Please tell us more about you.': 'ספרי לנו קצת עלייך.',
    'Email address (Required)': 'כתובת אימייל (חובה)',
    'We respect your privacy.': 'אנחנו מכבדות את הפרטיות שלך.',
    'Display name (Required)': 'שם לתצוגה (חובה)',
    'Post review as anonymous': 'פרסום הביקורת בעילום שם',
    'Submit': 'שליחה',
    'Submit review': 'שליחת ביקורת',
    'Thank you!': 'תודה רבה!',
    'Your review has been submitted': 'הביקורת שלך נשלחה',
    'Be the first to write a review': 'היי הראשונה לכתוב ביקורת',
    'No items found': 'עדיין אין ביקורות',
    'Filters': 'סינון',
    'Reviews': 'ביקורות'
  };
  var placeholders = { 'Start writing here...': 'התחילי לכתוב כאן...', 'Your email address': 'כתובת האימייל שלך', 'Display name': 'שם לתצוגה' };
  function translate(root){
    if(!root || root.nodeType === 8) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), node;
    while((node = walker.nextNode())){
      var raw = node.nodeValue, t = raw.trim();
      if(!t || t.length > 80) continue;
      if(dict[t]){ node.nodeValue = raw.replace(t, dict[t]); continue; }
      var m = t.match(/^(\d+)\s+reviews?$/i);
      if(m) node.nodeValue = raw.replace(t, m[1] + ' ביקורות');
    }
    if(root.querySelectorAll){
      root.querySelectorAll('input[placeholder],textarea[placeholder]').forEach(function(el){ if(placeholders[el.placeholder]) el.placeholder = placeholders[el.placeholder]; });
    }
  }
  var JM = '[class*="jdgm"],[class*="jm-"],#judgeme_product_reviews';
  function inWidget(el){ return el && el.closest && el.closest(JM); }
  translate(document.body);
  new MutationObserver(function(muts){
    muts.forEach(function(m){
      if(m.type === 'characterData'){ if(inWidget(m.target.parentElement)) translate(m.target.parentElement); return; }
      m.addedNodes.forEach(function(n){
        if(n.nodeType === 3){ if(inWidget(n.parentElement)) translate(n.parentElement); return; }
        if(n.nodeType === 1 && (inWidget(n) || (n.querySelector && n.querySelector(JM)))) translate(n);
      });
    });
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();
